<template>
    <div>

        <!-- Reviews -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-clipboard"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Reviews
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#reviews" aria-expanded="true" aria-controls="reviews">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="reviews">

                <div class="text-lg fw-medium">
                    <span class="round-icon round-xl bg-lightgreen text-green h3 me-2 fw-semibold">
                        {{ this.data.statistics.gemiddelde }}
                    </span>
                    {{ this.data.statistics.aantalbeoordelingen }} beoordelingen
                </div>

                <ul class="reviews list-unstyled w-100 mb-0">
                    <li class="d-flex gap-2 pb-1 mt-3 border-bottom border-default align-items-center"
                        v-for="review in this.data.reviews">
                        <div>
                            <p class="mb-0 text-sm fw-semibold">
                                {{ review.author }}
                            </p>
                            <p class="mb-0 text-lightgrey text-xs">
                                {{ review.review }}
                            </p>
                        </div>
                        <p class="mb-0 text-green ms-auto mx-2 text-lg fw-semibold">
                            {{ review.rating }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>

    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'reviews',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {
                    statistics: {
                        aantalbeoordelingen: '',
                        avarages: {},
                        gemiddelde: '',
                        percentageaanbeveling: '',
                        update: '',
                    },
                    reviews: [{
                        key: {
                            author: '',
                            review: '',
                            rating: '',
                        }
                    }],
                },

                componentId: 'reviews-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getReviews();
                }
            },
            getReviews() {
                axios.get('api/reviews')
                    .then(response => {
                       this.data = response.data;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
        },
        mounted() {
            if(this.isVisible) {
                this.getReviews();
            } else {
                this.loading = false;
            }
        },
        created() {},
    }
</script>
